import React from 'react';

interface ActionButtonProps {
  onClick?: (e: React.MouseEvent) => void;
  variant?: 'default' | 'supreme';
  isAvailable?: boolean;
  isLive?: boolean;
}

export const CallButton: React.FC<ActionButtonProps> = ({ 
  onClick, 
  isAvailable = true,
  isLive = false
}) => {
  const baseStyles = "flex flex-col items-center justify-center p-2 rounded-xl transition-all duration-300";
  
  // 🟢 FIXED: Removed the 'supreme' check. It stays beautifully blue!
  const activeColorStyles = "bg-blue-200 text-blue-600 hover:bg-blue-300 active:scale-95 group/btn";

  const disabledStyles = "bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200 opacity-80";

  const canClick = isAvailable && !isLive;
  const finalStyles = `${baseStyles} ${canClick ? activeColorStyles : disabledStyles}`;

  return (
    <button 
      onClick={canClick ? onClick : undefined} 
      disabled={!canClick} 
      className={finalStyles}
      title={isLive ? "Expert is currently in a Live Session" : ""}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 mb-1 ${canClick ? 'group-hover/btn:scale-110 transition-transform' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
      </svg>
      <span className="text-[10px] font-bold">Call</span>
    </button>
  );
};